export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9047.0908ea4b.jpg";